module.exports = __webpack_public_path__ + "img/error.ef6d3451.svg";